import { useEffect, useState } from 'react';

/** האם media query מתקיימת עכשיו (למשל מסך מחשב), ומתעדכן כשהחלון משנה גודל */
export function useMedia(q) {
  const [m, setM] = useState(() => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(q), h = () => setM(mq.matches);
    h();
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, [q]);
  return m;
}
